import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Divider, styled } from '@mui/material';
import { useState } from 'react';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const StyledList = styled(List)(({ theme }) => ({
  padding: 0,
  '& .MuiListItem-root': {
    padding: 0,
  },
  '& .MuiListItemButton-root': {
    padding: '8px 16px',
    minHeight: 40,
    '&:hover': {
      backgroundColor: '#142535 !important',
    },
  },
  '& .MuiListItemIcon-root': {
    minWidth: 32,
    fontSize: 15,
  },
  '& .MuiListItemText-primary': {
    fontSize: 12,
  },
}));

interface MenuItemType {
  Icon?: React.ReactNode;
  label: string;
  onMenuItemClick?: () => void;
  subItems?: MenuItemType[];
}

interface FluxNestedMenuProps {
  items: MenuItemType[];
  onItemClick?: () => void;
}

interface FluxNestedMenuItemProps {
  item: MenuItemType;
  onItemClick?: () => void;
}

const FluxNestedMenuItem = ({ item, onItemClick }: FluxNestedMenuItemProps) => {
  const [open, setOpen] = useState(false);
  const hasSubItems = item.subItems && item.subItems.length > 0;

  const handleClick = () => {
    if (hasSubItems) {
      setOpen(!open);
    } else if (item.onMenuItemClick) {
      item.onMenuItemClick();
      onItemClick?.();
    }
  };

  return (
    <>
      <ListItem disablePadding>
        <ListItemButton onClick={handleClick}>
          {item.Icon && <ListItemIcon>{item.Icon}</ListItemIcon>}
          <ListItemText primary={item.label} />
          {hasSubItems && (open ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>
      </ListItem>
      {hasSubItems && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.subItems!.map((subItem, index) => (
              <FluxNestedMenuItem key={index} item={subItem} onItemClick={onItemClick} />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

export const FluxNestedMenu = ({ items, onItemClick }: FluxNestedMenuProps) => {
  return (
    <StyledList>
      {items.map((item, index) => (
        <div key={index}>
          <FluxNestedMenuItem item={item} onItemClick={onItemClick} />
          {index < items.length - 1 && <Divider style={{ marginTop: 0, marginBottom: 0 }} />}
        </div>
      ))}
    </StyledList>
  );
};
